import { baseRequest } from './api';

const fetchLocations = async () => {
  try {
    const { status, data } = await baseRequest({
      method: 'GET',
      path: `/location/locations/`,
    });
    if (status === 200 || status === 201) {
      return data;
    }
  } catch (e) {
    console.error(e);
  }
  return null;
};

const fetchMatch = async (matchId) => {
  try {
    const { status, data } = await baseRequest({
      method: 'GET',
      path: `/match/${matchId}/`,
    });
    if (status === 200 || status === 201) {
      return data;
    }
  } catch (e) {
    console.error(e);
  }
  return null;
};

// Public club list: excludes clubs that belong to TURNIIRIVEEB.
const fetchClubs = async () => {
  try {
    const { status, data } = await baseRequest({
      method: 'GET',
      path: `/club/clubs/`,
    });
    if (status === 200 || status === 201) {
      return data;
    }
  } catch (e) {
    console.error(e);
  }
  return null;
};

// Admin club list: every club regardless of source, so admins do not recreate an existing club.
const fetchAdminClubs = async () => {
  try {
    const { status, data } = await baseRequest({
      method: 'GET',
      path: `/club/admin`,
    });
    if (status === 200 || status === 201) {
      return data;
    }
  } catch (e) {
    console.error(e);
  }
  return null;
};

const fetchPlayers = async () => {
  try {
    const { status, data } = await baseRequest({
      method: 'GET',
      path: `/player/players/`,
    });
    if (status === 200 || status === 201) {
      return data;
    }
  } catch (e) {
    console.error(e);
  }
  return null;
};

const fetchClubMembers = async () => {
  try {
    const { status, data } = await baseRequest({
      method: 'GET',
      path: `/club/clubMembers/`,
    });
    if (status === 200 || status === 201) {
      return data;
    }
  } catch (e) {
    console.error(e);
  }
  return null;
};

const fetchAdminMatches = async () => {
  try {
    const { status, data } = await baseRequest({
      method: 'GET',
      path: `/match/admin-matches/`,
    });
    if (status === 200 || status === 201) {
      return data;
    }
  } catch (e) {
    console.error(e);
  }
  return null;
};

const fetchTeams = async () => {
  try {
    const { status, data } = await baseRequest({
      method: 'GET',
      path: `/team/teams/`,
    });
    if (status === 200 || status === 201) {
      return data;
    }
  } catch (e) {
    console.error(e);
  }
  return null;
};

const fetchAdminSeasons = async () => {
  try {
    const { status, data } = await baseRequest({
      method: 'GET',
      path: `/season/admin-seasons/`,
    });
    if (status === 200 || status === 201) {
      return data;
    }
  } catch (e) {
    console.error(e);
  }
  return null;
};

const fetchMatchDays = async (leagueId) => {
  try {
    const { status, data } = await baseRequest({
      method: 'GET',
      path: `/league/${leagueId}/match-days/`,
    });
    if (status === 200 || status === 201) {
      return data;
    }
  } catch (e) {
    console.error(e);
  }
  return null;
};

const fetchTopPlayers = async (leagueId) => {
  try {
    const { status, data } = await baseRequest({
      method: 'GET',
      path: `/statistics/${leagueId}/top-players/`,
    });
    if (status === 200 || status === 201) {
      return data;
    }
  } catch (e) {
    console.error(e);
  }
  return null;
};

const fetchRoundRecords = async (leagueId) => {
  try {
    const { status, data } = await baseRequest({
      method: 'GET',
      path: `/statistics/${leagueId}/round-records/`,
    });
    if (status === 200 || status === 201) {
      return data;
    }
  } catch (e) {
    console.error(e);
  }
  return null;
};

const fetchAdminLeagues = async () => {
  try {
    const { status, data } = await baseRequest({
      method: 'GET',
      path: `/league/admin-leagues/`,
    });
    if (status === 200 || status === 201) {
      return data;
    }
  } catch (e) {
    console.error(e);
  }
  return null;
};

const fetchUsers = async () => {
  try {
    const { status, data } = await baseRequest({
      method: 'GET',
      path: `/user/users/`,
    });
    if (status === 200 || status === 201) {
      return data;
    }
  } catch (e) {
    console.error(e);
  }
  return null;
};

const patchLeague = async (leagueId, payload) => {
  try {
    const { status, data } = await baseRequest({
      method: 'PATCH',
      path: `/league/${leagueId}/`,
      data: payload,
    });
    if (status === 200 || status === 201) {
      return data;
    }
  } catch (e) {
    console.error(e);
  }
  return null;
};

const patchMatch = async (payload) => {
  try {
    const { status, data } = await baseRequest({
      method: 'PATCH',
      path: '/match/',
      data: payload,
    });
    if (status === 200 || status === 201) {
      return data;
    }
  } catch (e) {
    console.error(e);
  }
  return null;
};

const patchIsMatchDateTimeConfirmed = async (matchId, payload) => {
  try {
    const { status, data } = await baseRequest({
      method: 'PATCH',
      path: `/match/${matchId}/isMatchDateTimeConfirmed/`,
      data: payload,
    });
    if (status === 200 || status === 201) {
      return data;
    }
  } catch (e) {
    console.error(e);
  }
  return null;
};

const patchMatchDateTime = async (matchId, payload) => {
  try {
    const { status, data } = await baseRequest({
      method: 'PATCH',
      path: `/match/${matchId}/matchDateTime/`,
      data: payload,
    });
    if (status === 200 || status === 201) {
      return data;
    }
  } catch (e) {
    console.error(e);
  }
  return null;
};

const patchSeason = async (seasonId, payload) => {
  try {
    const { status, data } = await baseRequest({
      method: 'PATCH',
      path: `/season/${seasonId}/`,
      data: payload,
    });
    if (status === 200 || status === 201) {
      return data;
    }
  } catch (e) {
    console.error(e);
  }
  return null;
};

// Unlike the other helpers here, the team-save calls rethrow: TeamPopup shows the backend's
// message (e.g. a duplicate player) and keeps the popup open, which swallowing the error made
// impossible. TeamPopup is the only caller.
const patchTeam = async (selectedTeamId, payload) => {
  const { data } = await baseRequest({
    method: 'PATCH',
    path: `/team/${selectedTeamId}/`,
    data: payload,
  });
  return data;
};

const postMatch = async (payload) => {
  try {
    const { status, data } = await baseRequest({
      method: 'POST',
      path: '/match/',
      data: payload,
    });
    if (status === 200 || status === 201) {
      return data;
    }
  } catch (e) {
    console.error(e);
  }
  return null;
};

const postLogin = async (payload) => {
  try {
    const { status, data } = await baseRequest({
      method: 'POST',
      path: '/auth/login',
      data: payload,
    });
    if (status === 200 || status === 201) {
      return data;
    }
  } catch (e) {
    console.error(e);
  }
  return null;
};

// Rethrows for the same reason as patchTeam above.
const postTeam = async (payload) => {
  const { data } = await baseRequest({
    method: 'POST',
    path: '/team/',
    data: payload,
  });
  return data;
};

const postLeague = async (payload) => {
  try {
    const { status, data } = await baseRequest({
      method: 'POST',
      path: '/league/',
      data: payload,
    });
    if (status === 200 || status === 201) {
      return data;
    }
  } catch (e) {
    console.error(e);
  }
  return null;
};

const postGenerateCalendar = async (payload) => {
  try {
    const { status, data } = await baseRequest({
      method: 'POST',
      path: '/calendar/generate/',
      data: payload,
    });
    if (status === 200 || status === 201) {
      return data;
    }
  } catch (e) {
    console.error(e);
  }
  return null;
};

const postSeason = async (payload) => {
  try {
    const { status, data } = await baseRequest({
      method: 'POST',
      path: '/season/',
      data: payload,
    });
    if (status === 200 || status === 201) {
      return data;
    }
  } catch (e) {
    console.error(e);
  }
  return null;
};

const postUser = async (payload) => {
  try {
    const { status, data } = await baseRequest({
      method: 'POST',
      path: '/user/',
      data: payload,
    });
    if (status === 200 || status === 201) {
      return data;
    }
  } catch (e) {
    console.error(e);
  }
  return null;
};

const postGenerateSecondRoundCalendar = async (payload) => {
  try {
    const { status, data } = await baseRequest({
      method: 'POST',
      path: '/calendar/generateSecondRound/',
      data: payload,
    });
    if (status === 200 || status === 201) {
      return data;
    }
  } catch (e) {
    console.error(e);
  }
  return null;
};

const deleteUser = async (userId) => {
  try {
    const { status } = await baseRequest({
      method: 'DELETE',
      path: `/user/${userId}/`,
    });
    if (status === 200 || status === 201) {
      return status;
    }
  } catch (e) {
    console.error(e);
  }
  return null;
};

const deleteLeague = async (leagueId) => {
  try {
    const { status } = await baseRequest({
      method: 'DELETE',
      path: `/league/${leagueId}/`,
    });
    if (status === 200 || status === 201) {
      return status;
    }
  } catch (e) {
    console.error(e);
  }
  return null;
};

const postDisqualifyTeam = async (leagueId, teamId) => {
  try {
    const { status } = await baseRequest({
      method: 'POST',
      path: `/league/${leagueId}/disqualify/${teamId}/`,
    });
    if (status === 200 || status === 201) {
      return status;
    }
  } catch (e) {
    console.error(e);
  }
  return null;
};

const fetchFutureMatches = async () => {
  try {
    const { status, data } = await baseRequest({
      method: 'GET',
      path: `/match/future-matches/`,
    });
    if (status === 200 || status === 201) {
      return data;
    }
  } catch (e) {
    console.error(e);
  }
  return null;
};

const fetchSeasons = async () => {
  try {
    const { status, data } = await baseRequest({
      method: 'GET',
      path: `/season/seasons/`,
    });
    if (status === 200 || status === 201) {
      return data;
    }
  } catch (e) {
    console.error(e);
  }
  return null;
};

const fetchCalendarLeague = async (leagueId) => {
  try {
    const { status, data } = await baseRequest({
      method: 'GET',
      path: `/calendar/league/${leagueId}/`,
    });
    if (status === 200 || status === 201) {
      return data;
    }
  } catch (e) {
    console.error(e);
  }
  return null;
};

const fetchPlayerStatistics = async (currentSeasonId) => {
  try {
    const { status, data } = await baseRequest({
      method: 'GET',
      path: `/statistics/players/${currentSeasonId}/`,
    });
    if (status === 200 || status === 201) {
      return data;
    }
  } catch (e) {
    console.error(e);
  }
  return null;
};

const fetchTeamStatistics = async (currentSeasonId) => {
  try {
    const { status, data } = await baseRequest({
      method: 'GET',
      path: `/statistics/teams/${currentSeasonId}/`,
    });
    if (status === 200 || status === 201) {
      return data;
    }
  } catch (e) {
    console.error(e);
  }
  return null;
};

const fetchSeasonTeamData = async (teamId, seasonId) => {
  try {
    const { status, data } = await baseRequest({
      method: 'GET',
      path: `/team/${teamId}/season/${seasonId}/`,
    });
    if (status === 200 || status === 201) {
      return data;
    }
  } catch (e) {
    console.error(e);
  }
  return null;
};

const fetchSeasonDetails = async (seasonId) => {
  try {
    const { status, data } = await baseRequest({
      method: 'GET',
      path: `/season/${seasonId}/`,
    });
    if (status === 200 || status === 201) {
      return data;
    }
  } catch (e) {
    console.error(e);
  }
  return null;
};

const fetchHomeTeam = async (homeTeamId) => {
  try {
    const { status, data } = await baseRequest({
      method: 'GET',
      path: `/team/${homeTeamId}/`,
    });
    if (status === 200 || status === 201) {
      return data;
    }
  } catch (e) {
    console.error(e);
  }
  return null;
};

const fetchAwayTeam = async (awayTeamId) => {
  try {
    const { status, data } = await baseRequest({
      method: 'GET',
      path: `/team/${awayTeamId}/`,
    });
    if (status === 200 || status === 201) {
      return data;
    }
  } catch (e) {
    console.error(e);
  }
  return null;
};

const fetchAdminPlayers = async () => {
  try {
    const { status, data } = await baseRequest({
      method: 'GET',
      path: `/player/admin`,
    });
    if (status === 200 || status === 201) {
      return data;
    }
  } catch (e) {
    console.error(e);
  }
  return null;
};

// Rethrows for the same reason as patchTeam/postTeam above: PlayerPopup shows the backend's
// message (e.g. a duplicate name) instead of silently dead-ending. PlayerPopup is the only caller.
const patchPlayer = async (id, payload) => {
  const { data } = await baseRequest({
    method: 'PATCH',
    path: `/player/${id}`,
    data: payload,
  });
  return data;
};

export {
  fetchAdminPlayers,
  patchPlayer,
  fetchLocations,
  fetchFutureMatches,
  fetchSeasons,
  fetchUsers,
  fetchMatch,
  fetchHomeTeam,
  fetchAwayTeam,
  fetchSeasonDetails,
  patchMatch,
  postMatch,
  fetchAdminMatches,
  fetchMatchDays,
  fetchTopPlayers,
  fetchRoundRecords,
  fetchAdminLeagues,
  postGenerateCalendar,
  postGenerateSecondRoundCalendar,
  fetchClubs,
  fetchAdminClubs,
  fetchClubMembers,
  fetchTeams,
  fetchAdminSeasons,
  patchLeague,
  patchSeason,
  postSeason,
  postLeague,
  deleteUser,
  deleteLeague,
  postDisqualifyTeam,
  fetchPlayerStatistics,
  fetchTeamStatistics,
  fetchSeasonTeamData,
  fetchPlayers,
  patchTeam,
  postTeam,
  postUser,
  postLogin,
  fetchCalendarLeague,
  patchIsMatchDateTimeConfirmed,
  patchMatchDateTime,
};
